import React from 'react'
import { DATA_TEST_ID } from 'shared-constants/build/testIds'
import { Flex } from 'components/Layout'
import Link from 'components/Link'
import { Text } from 'components/Typography'
import { CURRENCY_ISO_CODE } from 'constants/common'
import { COLOR_INTENT, FONT_SIZE, FONT_WEIGHT, SPACE } from 'Theme'
import { getTacPageUrl } from 'utils/promoEngine'
import { ProductPrice } from '../../ProductPrice'

export const DiscountDisplay = ({
  allItemsDiscountEligible,
  totalDiscount,
  linkToTerms,
}: {
  allItemsDiscountEligible: boolean
  totalDiscount: number
  linkToTerms?: string
}) => (
  <Flex
    justifyContent="space-between"
    data-test-id={DATA_TEST_ID.SHOWROOM_CHECKOUT_SUMMARY_TOTAL_DISCOUNT}
  >
    <Flex flexDirection="column">
      <Text
        fontSize={FONT_SIZE.PX_14}
        fontWeight={FONT_WEIGHT.MEDIUM}
        color={COLOR_INTENT.DISCOUNT.CODE_APPLIED}
      >
        Discount
      </Text>
      <Flex flexDirection="column" mt={{ MOBILE: SPACE.PX_12, TABLET: 0 }}>
        <>
          {allItemsDiscountEligible ? (
            <Text fontSize={FONT_SIZE.PX_12}>
              <Link
                target="_blank"
                href={getTacPageUrl(linkToTerms)}
                fontSize={FONT_SIZE.PX_12}
              >
                Terms &amp; Conditions
              </Link>{' '}
              apply
            </Text>
          ) : (
            <>
              <Text fontSize={FONT_SIZE.PX_12} color={COLOR_INTENT.GRAY_90}>
                Some items may not be eligible for discount.
              </Text>
              <Link
                target="_blank"
                width="fit-content"
                textDecoration="underline"
                fontSize={FONT_SIZE.PX_12}
                color={COLOR_INTENT.GRAY_90}
                href={getTacPageUrl(linkToTerms)}
                aria-label="Learn more about items non-eligibility"
              >
                Learn more
              </Link>
            </>
          )}
        </>
      </Flex>
    </Flex>
    <ProductPrice
      price={{
        total: totalDiscount,
        currencyIsoCode: CURRENCY_ISO_CODE.USD,
      }}
      color={COLOR_INTENT.DISCOUNT.CODE_APPLIED}
      isDiscount
    />
  </Flex>
)
